import React from "react";

export default function NeedleSummary({ needleProperty }) {
    if (!needleProperty || Object.keys(needleProperty).length === 0) {
        return <span style={{ color: "#888" }}>Click to add Needle</span>;
    }

    // Runs imported without a needle size come back with needleDefinition: null
    const { needleType } = needleProperty;
    const needleDefinition = needleProperty.needleDefinition || {};

    const renderField = (label, value, unit = "") => {
        if (value === null || value === "" || typeof value === "undefined") return null;
        const displayUnit = unit || "G";
        return (
            <div key={label}>
                <strong>{label}:</strong> {value} {displayUnit}
            </div>
        );
    };

    return (
        <div>
            {renderField("Type", needleType)}

            {/* Type-specific fields */}
            {needleType === "Single Needle" &&
                renderField("Diameter", needleDefinition.diameter, needleDefinition.diameterUnit)}

            {needleType === "Coaxial" && (
                <>
                    {renderField("Inner Diameter", needleDefinition.innerDiameter, needleDefinition.innerDiameterUnit)}
                    {renderField("Outer Diameter", needleDefinition.outerDiameter, needleDefinition.outerDiameterUnit)}
                </>
            )}

            {needleType === "Triaxial" && (
                <>
                    {renderField("Inner Diameter", needleDefinition.innerDiameter, needleDefinition.innerDiameterUnit)}
                    {renderField("Middle Diameter", needleDefinition.middleDiameter, needleDefinition.middleDiameterUnit)}
                    {renderField("Outer Diameter", needleDefinition.outerDiameter, needleDefinition.outerDiameterUnit)}
                </>
            )}

            {needleType === "Needle Array" && (
                <>
                    {renderField("Number of Needles", needleDefinition.numNeedles)}
                    {renderField("Needle Spacing", needleDefinition.needleSpacing, "mm")}
                    {renderField("Needle Type in Array", needleDefinition.needleType)}
                    {/* Render relevant inner type fields if available */}
                    {needleDefinition.needleType === "Single Needle" &&
                        renderField("Inner Needle Diameter", needleDefinition.diameter, needleDefinition.diameterUnit)}
                    {needleDefinition.needleType === "coaxial" && (
                        <>
                            {renderField("Inner Needle Inner Diameter", needleDefinition.innerDiameter, needleDefinition.innerDiameterUnit)}
                            {renderField("Inner Needle Outer Diameter", needleDefinition.outerDiameter, needleDefinition.outerDiameterUnit)}
                        </>
                    )}
                </>
            )}

            {needleType === "Needleless" &&
                renderField("Surface Type", needleDefinition.surfaceType)}

            {renderField("Material", needleDefinition.material)}
        </div>
    );
}
